// style-view.js

import $    from 'jquery';
import BasePropertyTabView      from 'properties/BasePropertyTabView';
import contentTemplate          from 'properties/style-view.ejs';
import propertyViewMapService   from 'PropertyViewMapService.js';
import listService              from 'ListService';
import constants        from 'Constants';

class StyleView extends BasePropertyTabView {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = '#propStyle';
        this.factoryKey = opts.factoryKey;


        super.initialize(opts);

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        //this.listenTo(this.model, 'change', this.render);
        return this;
    }

    render(opts) {
        this.clearPropertyViews();

        super.render();

        this.factoryKey = this.model.attributes.factoryKey;
        this.multipleSelected = (opts && opts.multipleSelected) || listService.selectedCount > 1;
        if (opts && opts.factoryKey) {
            this.factoryKey = opts.factoryKey;
        }

        let propStyle = $('#propStyle');
        propStyle.css('width', '');

        if (this.model.get('factoryKey') === 'layout_frame' || this.model.get('factoryKey') === 'reports_frame') {
            propStyle.css('width','100%');
        } 

        // Render Property Views
        let views = [];
        if (listService.mainKind === constants.KIND_MOBILE) {
            views = propertyViewMapService.getMobileStyleViews(this.factoryKey);
        }
        else {
            if (this.multipleSelected) {
                views = propertyViewMapService.getMultipleSelectedStyleViews();
                this.model = listService.combineSelectedModels();
                
                const allKeys = listService.selected.map((obj, index) => obj.model.get('factoryKey'));
                this.model.set('factoryKeys', allKeys, {silent: true});

            } else {
                views = propertyViewMapService.getStyleViews(this.factoryKey);
            }
        }

        this.renderPropertyViews(views, this.model);

        return this;
    }


}

export default StyleView;
